import { AfterViewInit, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

import { $digitalPropertyMonitoring } from '../../../../../../../shared/constants/digital-properties';
import {
  AuditToolCommonNames,
  AuditToolCommonNamesToAuditToolNames,
  AuditToolNames,
} from '../../../../../../../shared/constants/audit-tool';
import { automatedNameAndLevels, standardNameAndLevel } from '../../../../../../../shared/constants/scanning';
import { IDigitalPropertyMonitoringDetails } from '../../../../../../../shared/interfaces/digital-property.interface';

@Component({
  selector: 'app-monitoring-scan-settings-step',
  templateUrl: './monitoring-scan-settings-step.component.html',
  styleUrls: ['./monitoring-scan-settings-step.component.scss'],
  standalone: false,
})
export class MonitoringScanSettingsStepComponent implements AfterViewInit {
  public readonly a11yStandards: readonly standardNameAndLevel[] = automatedNameAndLevels;
  public $digitalPropertyMonitoring: typeof $digitalPropertyMonitoring = $digitalPropertyMonitoring;

  @Input() public stepNumber: number;
  @Input() public form: UntypedFormGroup;
  @Input() public formValidationRequest$: Subject<void>;
  @Input() public toolName: AuditToolCommonNames;

  public get testingTool(): AuditToolNames {
    return AuditToolCommonNamesToAuditToolNames[this.toolName];
  }

  @Input() public monitoring: IDigitalPropertyMonitoringDetails;

  private initializeForm(): void {
    if (this.monitoring?.[$digitalPropertyMonitoring.conformanceLevel]) {
      this.form
        .get($digitalPropertyMonitoring.conformanceLevel)
        .setValue(this.monitoring[$digitalPropertyMonitoring.conformanceLevel]);
    }
    if (this.monitoring?.[$digitalPropertyMonitoring.viewport]) {
      this.form.get($digitalPropertyMonitoring.viewport).setValue(this.monitoring[$digitalPropertyMonitoring.viewport]);
    }
  }

  ngAfterViewInit(): void {
    this.initializeForm();
  }
}
